import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ColorPicker, BasePopoverPanel } from 'crazyEditor/components/EditorUI/BaseUI/index';
import _ from 'lodash';
import { connect } from 'react-redux';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import MenuItem from 'material-ui/MenuItem';
import { setElementUpdatePreview, clearElementUpdatePreview } from 'crazyEditor/redux/modules/element/actions/previewElementActions';
import { updateDesktopElement } from 'crazyEditor/redux/modules/element/actions/desktopElementActions';
import {getBackgroundTextureSetter, getBackgroundGradientSetter} from 'crazyEditor/core/elements/utils/commonElementMethods';
import { BORDER_PANEL_TYPE, BORDER_RADIUS_PROP_NAMES } from 'crazyEditor/core/constants/panelConstants';
import { getElementMethods } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import * as Colors from 'material-ui/styles/colors';
import SimpleSelectableBox from 'crazyEditor/components/EditorUI/BaseUI/SelectableBoxes/SimpleSelectableBox';

const TEXTURE_THUMBNAIL_SIZE = 80;

const styles = {
  container: {
    maxHeight: 400,
    width: 284,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  }
};

const shadow = [
  'rgba(0, 0, 0, 0.247059) 0px 0px 8px 0px',
  'rgba(0, 0, 0, 0.498039) 0px 0px 8px 0px',
  'rgba(0, 0, 0, 0.8) 0px 0px 10px 0px',
  'rgba(0, 0, 0, 0.8) 5px 5px 10px 0px',
  'rgba(0, 0, 0, 0.8) 0px 0px 30px 0px',
  'rgba(0, 0, 0, 0.8) -1px -1px 10px 0px',
  'rgba(0, 0, 0, 0.8) -5px -5px 10px 0px',
  'rgba(0, 0, 0, 0.8) -10px -10px 10px 0px',
  'rgba(0, 0, 0, 0.8) 10px 0px 10px 0px',
  'rgba(0, 0, 0, 0.8) 0px 10px 10px 0px',
  'rgba(0, 0, 0, 0.8) -10px 0px 10px 0px'
];

function isNoBorder(style) {
  return _.isNil(style) || style.toLowerCase() === 'none';
}

function isBorderStyleEqual(style1, style2) {
  return isNoBorder(style1) && isNoBorder(style2) ||
    (!isNoBorder(style1) && !isNoBorder(style2) && style1.toLowerCase() === style2.toLowerCase());
}

@connect(
  false,
  {closeLazyPanel, setElementUpdatePreview, clearElementUpdatePreview, updateDesktopElement}
)
export default class ShadowPanel extends Component {

  constructor(props) {
    super();
    this.state = {};
    this.initWithProps(props);
  }

  componentWillReceiveProps(nextProps) {
    this.initWithProps(nextProps);
  }

  onChange = (value) => {
    const { panelProps, setElementUpdatePreview, open } = this.props;
    const { selectedElementIds } = panelProps;

    if (!open) {
      return;
    }

    this.setState({previewValue: value});
    setElementUpdatePreview(selectedElementIds, this.getSetter(value));
  };

  onCancel = () => {
    const { closeLazyPanel, panelName, clearElementUpdatePreview} = this.props;

    clearElementUpdatePreview();
    closeLazyPanel(panelName);
  };

  onSelect = (value, closePanel = true) => {
    const { closeLazyPanel, updateDesktopElement, panelProps } = this.props;
    const { selectedElementIds } = panelProps;

    updateDesktopElement(selectedElementIds, this.getSetter(value));
    if (closePanel) {
      closeLazyPanel(this.props.panelName);
    } else {
      this.setState({previewValue: value});
    }
  };


  initWithProps(props) {
    const { panelProps} = props;
    const { selectedElements } = panelProps;
    this.element = selectedElements[0];
    const elementMethods = getElementMethods(this.element.type);
    this.getSetter = elementMethods.getBoxShadowSetter;
    this.extractInitialValue();
  }

  extractInitialValue() {
    const relevantProps = _.keys(this.getSetter(null).compProps);
    const initialValue = _.pick(this.element.compProps, relevantProps);
    if (relevantProps.length > 1) {
      this.state.initialValue = initialValue;
    } else if (relevantProps.length === 1) {
      this.state.initialValue = _.get(_.values(initialValue), '[0]', null);
    }
    this.state.previewValue = this.state.initialValue;
  }

  render() {
    const { panelName, anchorEl, open, panelProps } = this.props;
    const { selectedElements, type } = panelProps;
    const { initialValue } = this.state;
    return (
      <BasePopoverPanel
        panelName={panelName}
        anchorEl={anchorEl}
        open={open}
        onRequestClose={this.onCancel}
        style={{width: 320, padding: 20}}
      >
        <div
          style={styles.container}
          onMouseLeave={this.props.clearElementUpdatePreview}
        >
          {
            [
              <SimpleSelectableBox key="SimpleSelectableBox-noShadow" selected={isNoBorder(initialValue)} style={{marginBottom: 12, backgroundColor: Colors.grey200}} borderType={'inside'}>
                <MenuItem
                  innerDivStyle={{height: TEXTURE_THUMBNAIL_SIZE, fontSize: 16, textAlign: 'center', lineHeight: '24px', display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: 0}}
                  primaryText={[<div>No</div>, <div>Shadow</div>]}
                  onMouseEnter={this.onChange.bind(this, null)} onClick={this.onSelect.bind(this, null)}
                  key={'MenuItem-noShadow'}
                  style={{borderWidth: 6, borderColor: Colors.grey700, width: TEXTURE_THUMBNAIL_SIZE, height: TEXTURE_THUMBNAIL_SIZE}}
                />
              </SimpleSelectableBox>,
              _.map(shadow, (value, index) => {
                return (
                  <SimpleSelectableBox key={`SimpleSelectableBox${index}`} selected={isBorderStyleEqual(value, initialValue)} style={{...this.getSetter(value).compProps, marginBottom: 12}} borderType={'inside'}>
                    <MenuItem onMouseEnter={this.onChange.bind(this, value)} onClick={this.onSelect.bind(this, value)} key={value} style={{width: TEXTURE_THUMBNAIL_SIZE, height: TEXTURE_THUMBNAIL_SIZE, backgroundColor: Colors.grey200}}/>
                  </SimpleSelectableBox>
                );
              })
            ]
          }
        </div>
      </BasePopoverPanel>
    );
  }
}

ShadowPanel.propTypes = {
  panelName: PropTypes.string.isRequired,
  anchorEl: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  panelProps: PropTypes.shape({
    selectedElementIds: PropTypes.array.isRequired,
    selectedElements: PropTypes.array.isRequired,
  })
};